// extracted by mini-css-extract-plugin
module.exports = {"switch__wrapper":"styles_switch__wrapper__TmdpU"};